type PaginationProps = {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
};

const getPages = (current: number, total: number): (number | '...')[] => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | '...')[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let p = start; p <= end; p += 1) pages.push(p);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
};

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = getPages(current, totalPages);

  return (
    <nav aria-label="分页导航" className="mt-8 flex items-center justify-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line text-base"></i>
        上一页
      </button>

      {pages.map((p, i) =>
        p === '...' ? (
          <span key={`gap-${i}`} className="px-1.5 text-sm text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === current ? 'page' : undefined}
            className={`flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium transition-colors ${
              p === current
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700'
            }`}
          >
            {p}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(current + 1)}
        disabled={current === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base"></i>
      </button>
    </nav>
  );
}